const user = JSON.parse(localStorage.getItem('user'))
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null }

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    onLogin ({ commit }, user) {
      commit('setStatus', { loggedIn: true, user: user })
    },
    onLogout ({ commit }) {
      commit('setStatus', { loggedIn: false, user: null })
    }
  },
  mutations: {
    setStatus (state, { loggedIn, user }) {
      state.status.loggedIn = loggedIn
      state.user = user
    }
  }
}
